import React, { useState, useEffect, useRef, useMemo } from "react";
import { Card, InputNumber, Row, Modal, Col, Input, DatePicker, Button, Table, Form, message, Select, Checkbox, Popconfirm, Spin, Space } from "antd";
import { UploadOutlined, PlusOutlined, DeleteOutlined, ReloadOutlined, EditOutlined, CreditCardOutlined, FileExcelOutlined, AppstoreOutlined, SaveOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../../api/axiosInstance";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { ColumnsType } from 'antd/es/table';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { request } from "http";
import FileInputComponent from "../../../../components/file-input/file-input";
import FileUpload, { FileUploadRef } from "../../../../components/file-input/FileUpload";
import { FilterRequest, OrderTypes, OrderValue } from "../../../../utils/Filters/FilterModels";
import FilterHelper from "../../../../utils/Filters/FilterHelper";
import { saveAs } from "file-saver";
import { TableRowSelection } from "antd/es/table/interface";
import "./tournament-detail.scss";
import TournamentGroups from "../../../../components/tournament-groups/tournament-groups";
import KnockoutSetupPopup, { GroupInfo, RoundConfig } from "../../../../components/knockout-setup-popup/KnockoutSetupPopup";
import GroupStageManagerPopup, { GroupStageConfig } from "../../../../components/group-stage-manager-popup/GroupStageManagerPopup";
import GroupStageMatchEditor, { GroupStageMatchEditorRef } from "../../../../components/group-stage-manager-popup/GroupStageMatchEditor";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

import KnockoutMatchTable from "../../../../components/knockout-setup-popup/KnockoutMatchTable";
const { TextArea } = Input;
const { Option } = Select;
const API_URL = process.env.REACT_APP_API_URL;
dayjs.extend(utc);

interface User {
    Id: string;
    dateOfBirth: string;
    fullName: string;
    gender: string;
    point: string;
    nickName: string;
}
interface Participant {
    participant1ID: string
    participant2ID: string
    participant1FullName: string
    participant2FullName: string
    participantFullName: string
    participantNickName: string
    participant1Point: number
    participant2Point: number
    totalPoint: number
}

interface RequestPartner {
    iD: string
    tournamentID: string
    fromProfileID: string
    fromProfileName: string
    fromProfileNickName: string
    fromProfilePoint: number
    fromProfileDoublePoint: number
    toProfileID: string
    toProfileName: string
    toProfileNickName: string
    toProfilePoint: number,
    toProfileDoublePoint: number,
    paymentCompleted: boolean,
    status: number,
    isAppCreated: boolean,
    matchTime: Date,
    totalPoint: number,
    totalDoublePoint: number
}
interface Matches {
    matchesID: string
    matchOrder: string
    round: number
    score1: number
    score2: number
    startDate: Date
    participant1FullName: string
    participant1_1FullName: string
    participant2_1FullName: string
    participant2FullName: string
}
const TournamentDetail: React.FC = () => {
    const { tournamentID } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [formListUser] = Form.useForm();
    const [formListPaticipant1] = Form.useForm();
    const [formListPaticipant2] = Form.useForm();
    const [formListMatches1] = Form.useForm();
    const [formListMatches2] = Form.useForm();
    const [fromStartDate] = Form.useForm();
    const [formCreateDataMatches] = Form.useForm();

    const [isOpenConfirmUpdatePoint, setOpenConfirmUpdatePoint] = useState(false);
    const [isCreateDataMatches, setCreateDataMatches] = useState(false);
    const [participant1, setParticipant1] = useState<any[]>([]);
    const [participant2, setParticipant2] = useState<any[]>([]);
    const [isOpenModelCreateDataMatches, setIsOpenModelCreateDataMatches] = useState(false);
    const [isModalUserVisible, setIsModalUserVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isModalMatches, setIsModalMatches] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(true);
    const [athletePairs, setAthletePairs] = useState<any[]>([]);
    const [listRequestPartnerByApp, setListRequestPartnerByApp] = useState<any[]>([]);
    const [listParticipant, setListParticipants] = useState<any[]>([]);
    const [listTournamentRegistrations, setDatalistTournamentRegistrations] = useState<any[]>([]);
    const [listUser, setListUsers] = useState<any[]>([]);
    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [matchInfor1, setMatchInfor1s] = useState<any>();
    const [matchInfor2, setMatchInfor2s] = useState<any>();
    const [listDataConfirmPayment, setListDataConfirmPayment] = useState<any[]>([]);
    const [matches, setMatches] = useState<any[]>([]);
    const [numberUserCompleteFee, setNumberUserCompleteFee] = useState<any>();
    const isSingleTournament = Form.useWatch('isSingleTournament', form);
    const [isOpenConfirmPayment, setOpenConfirmPayment] = useState(false);
    const [focusedRowKey, setFocusedRowKey] = useState<number | null>(null);

    const fileUploadRef = useRef<FileUploadRef>(null);
    const qrCodeUploadRef = useRef<FileUploadRef>(null);
    const [imagePath, setImagePath] = useState<string>();
    const [qrCode, setQrCode] = useState<string>();
    const [hasNewImage, setHasNewImage] = useState(false);
    const [hasNewQr, setHasNewQr] = useState(false);
    const [filter, setFilter] = useState<FilterRequest>(new FilterRequest({
        page: 1,
        limit: 5000,
        keyword: '',
        summary: '',
        filters: [],
        orders: [new OrderValue({ propertyName: 'userCode', type: OrderTypes.Desc, index: 0 })
        ],
        isFull: false,
        tree: false,
    }));

    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const [selectedRowKeyParticipants, setSelectedRowKeyParticipants] = useState<any[]>([]);

    // Popup Danh sách cặp VĐV ghép đôi trên App
    const [isOpenListRequestPartnerByApp, setOpenListRequestPartnerByApp] = useState(false);
    const [isOpenDeleteRequestPartnerByApp, setOpenDeleteRequestPartnerByApp] = useState(false);
    const [selectedRequestPartnerByApp, setSelectedRequestPartnerByApp] = useState<any>();

    // bảng thi đấu vòng loại
    const [isOpenTournamentGroup, setOpenTournamentGroups] = useState(false);
    const [isOpenDeleteTournamentGroup, setOpenDeleteTournamentGroups] = useState(false);
    const [listParticipantTournamentGroup, setListParticipantTournamentGroups] = useState<any[]>([]);
    const [selectedGroup, setSelectedGroup] = useState<string | null>(null);

    // Popup tạo dữ liệu trận đấu
    const [isOpenKnockoutSetupPopup, setOpenKnockoutSetupPopup] = useState(false);
    const [groups, setGroups] = useState<GroupInfo[]>([]);
    const matchEditorRef = useRef<GroupStageMatchEditorRef>(null);
    // Tạo dữ liệu trận
    const [isOpenConfirmCreateDataMatches, setOpenConfirmCreateDataMatches] = useState(false);
    const [roundData, setRoundData] = useState<RoundConfig | null>(null);

    // fake data
    useEffect(() => {
        if (!tournamentID) return;
        fetchGroups();
    }, [tournamentID]);


    const fetchGroups = async () => {
        try {
            const res = await axiosInstance.get(
                `${API_URL}/v1/tournament-group/get-tournament-group-by-tournamentID/${tournamentID}`
            );

            const mapped: GroupInfo[] = res.data
                .map((g: any) => ({
                    id: g.tournamentGroupID,
                    group: g.name.trim(), // ✅ lấy nguyên “Bảng A”, “Bảng B”
                }))
                // sắp theo bảng A, B, C...
                .sort((a: any, b: any) => a.group.localeCompare(b.group, "vi", { numeric: true }));

            setGroups(mapped);
        } catch (err) {
            console.error(err);
            message.error("Không thể lấy danh sách bảng đấu!");
        }
    };


    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys: any[]) => {
            setSelectedRowKeys(selectedKeys);
            console.log('selectedKeys', selectedKeys);

        },
    };

    const rowSelectionParticipant = {
        selectedRowKeys: selectedRowKeyParticipants,
        onChange: (value: any[], selectedRows: any[]) => {
            setSelectedRowKeyParticipants(value);
            setListDataConfirmPayment(selectedRows);
        },
    };

    useEffect(() => {
        if (tournamentID) {
            setIsEditing(false);
            getRequestPartner();
            fetchTournamentData();
            fetchTourRegistrationsData();
            fetchMatches();
            fetchTournamentMatchConfig();
        }
        const observer = new ResizeObserver(() => { });
        return () => observer.disconnect(); // Cleanup khi component unmount
    }, [tournamentID]);


    // GetData
    const fetchTournamentData = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/v1/tournaments/${tournamentID}`);
            const tournament = response.data;
            // setAthletePairs(tournament.matchedParticipants);
            form.setFieldsValue({
                ...((tournament && typeof tournament === "object") ? tournament : {}),
                organizingTime: tournament?.organizingTime ? dayjs(tournament.organizingTime) : null,
                registerDueDate: tournament?.registerDueDate ? dayjs(tournament.registerDueDate) : null,
            });
            setImagePath(tournament.tournamentImage);
            setQrCode(tournament.qrCode);
        } catch (error) {
            message.error("Không thể tải thông tin giải đấu!");
        }
    };

    const fetchTourRegistrationsData = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${API_URL}/v1/tournaments/get-user-by-invitation?tournamentID=${tournamentID}`);
            const tournamentRegistrations = response.data;
            setDatalistTournamentRegistrations(tournamentRegistrations)
        } catch (error) {
            message.error("Không thể tải danh sách thành viên tham gia giải đấu!");
        }
        finally {
            setLoading(false);
        }
    };

    const getListParticipant = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${API_URL}/v1/tournaments/get-list-participant?tournamentID=${tournamentID}`);
            const tournamentRegistrations = response.data;
            const formattedData: Participant[] = tournamentRegistrations.map((item: any) => ({
                participantID: item.participantID,
                participant1ID: item.participant1ID,
                participant2ID: item.participant2ID,
                participant1FullName: item.participant1FullName,
                participant2FullName: item.participant2FullName,
                participantNickName: item.participant1NickName + ' - ' + item.participant2NickName,
                participant1Point: item.participant1Point ?? 0,
                participant2Point: item.participant2Point ?? 0,
                totalPoint: (Number(item.participant1Point) || 0) + (Number(item.participant2Point) || 0)
            }));
            setListParticipants(formattedData)

        } catch (error) {
            message.error("Không thể tải danh sách thành viên tham gia giải đấu!");
        }
        finally {
            setLoading(false);
        }
    };

    const deleteTournamentRegistration = async (id: string) => {

        try {
            await axiosInstance.put(`/tournaments/delete-tour-registration`, { tourRegistrationIds: [id] });
            fetchTourRegistrationsData();
            message.success("Xoá người tham gia giải đấu thành công!");
        } catch (error) {
            console.error("Lỗi khi xóa người tham gia giải đấu:", error);
        }
    }

    const handleDeleteRequestPartner = async (record: any) => {
        try {
            if (record.paymentCompleted === false) {
                await axiosInstance.put(`/tournaments/delete-request-partner`, { requestPartnerIds: [record.iD] });
                getRequestPartner();
                message.success("Xoá cặp vận động viên thành công!");
            } else {
                message.error("Bạn không thể xoá cặp vận động viên đã thanh toán!");
            }

        } catch (error) {
            console.error("Lỗi khi xóa cặp vđv", error);
        }
    }

    const getListUser = async (paramValues?: any) => {
        try {
            const params = FilterHelper.getParamWithFilter(filter);

            const response = await axiosInstance.get("/user", {
                params: params,
            });
            const users = response.data?.list || [];
            const formattedData: User[] = users.map((item: any) => ({
                id: item.id,
                dateOfBirth: item.dateOfBirth,
                userCode: item.userCode,
                fullName: item.fullName || "Không có tên",
                gender: item.gender || "Nam",
                point: item.point || "Chưa có điểm",
                doublePoint: item.doublePoint || "Chưa có điểm",
                nickName: item.nickName || "Không xác định",
            }));
            const listUsers = formattedData.filter(a =>
                !listTournamentRegistrations.some(b => b.requesterId === a.Id)
            );

            setListUsers(listUsers)
        } catch (error) {
            message.error("Không thể tải danh sách thành viên tham gia giải đấu!");
        }
    };

    const getRequestPartner = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${API_URL}/v1/tournaments/get-request-partner-admin?tournamentID=${tournamentID}`);
            const tournamentRegistrations = response.data;
            const formattedData: RequestPartner[] = tournamentRegistrations.map((item: any) => ({
                key: item.id,
                iD: item.id,
                tournamentID: item.tournamentID,
                fromProfileID: item.fromProfileID,
                fromProfileNickName: item.fromProfileNickName,
                fromUserCode: item.fromUserCode,
                fromProfileName: item.fromProfileName,
                fromProfilePoint: item.fromProfilePoint,
                fromProfileDoublePoint: item.fromProfileDoublePoint,
                toProfileID: item.toProfileID,
                toProfileName: item.toProfileName,
                toProfileNickName: item.toProfileNickName,
                toUserCode: item.toUserCode,
                toProfilePoint: item.toProfilePoint,
                toProfileDoublePoint: item.toProfileDoublePoint,
                paymentCompleted: item.paymentCompleted,
                status: item.status,
                isAppCreated: item.isAppCreated,
                matchTime: item.matchTime,
                totalPoint: ((item.fromProfilePoint ?? 0) + (item.toProfilePoint ?? 0)),
                totalDoublePoint: ((item.fromProfileDoublePoint ?? 0) + (item.toProfileDoublePoint ?? 0)),
            }));

            setAthletePairs(formattedData)
            setNumberUserCompleteFee(formattedData.filter(a => a.paymentCompleted === true).length)
        } catch (error) {
            message.error("Không thể tải danh sách thành viên tham gia giải đấu!");
        }
        finally {
            setLoading(false);
        }
    }

    const fetchMatches = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/v1/matches/${tournamentID}`);

            const formattedData: Matches[] = response.data
                .map((item: any) => ({
                    matchID: item.matchID,
                    participantID_1: item.participantID_1,
                    participantID_2: item.participantID_2,
                    participant1FullName: item.participant1FullName,
                    participant1_1FullName: item.participant1_1FullName,
                    participant1_1_1FullName: item.participant1FullName + ' - ' + item.participant1_1FullName,
                    participant2FullName: item.participant2FullName,
                    participant2_1FullName: item.participant2_1FullName,
                    participant2_2_2FullName: item.participant2FullName + ' - ' + item.participant2_1FullName,
                    matchOrder: item.matchOrder ?? 1,
                    round: item.round,
                    score1: item.score1,
                    score2: item.score2,
                    startDate: item.startDate ? dayjs(item.startDate.toString()).format("DD/MM/YYYY") : null,
                }))
                .filter((match: any) =>
                    (match.participantID_1 !== "00000000-0000-0000-0000-000000000000" &&
                        match.participantID_1 !== null) || (match.participantID_2 !== "00000000-0000-0000-0000-000000000000" &&
                            match.participantID_2 !== null)
                )
                .sort((a: any, b: any) =>
                    a.round - b.round || a.matchOrder - b.matchOrder
                );
            if (formattedData.length > 0) {
                setCreateDataMatches(true)
            }
            setMatches(formattedData);
        } catch (error) {
            console.error("Lỗi khi fetch dữ liệu:", error);
        }
    };

    const fetchTournamentMatchConfig = async () => {
        try {
            const data = await axiosInstance.get(`${API_URL}/v1/tournament-round/get-tournament-match-config-by-tournamentID/${tournamentID}`);
            const mappedRound: RoundConfig = {
                totalTeams: Number(data.data.totalTeams),
                matches: (data.data.tournamentMatchConfigs || []).map(
                    (m: any, index: number) => ({
                        id: index + 1, // hoặc m.matchNumber nếu bạn muốn dùng matchNumber làm ID
                        matchesCode: m.matchNumber ?? index + 1,
                        team1: m.groupName1 || null,
                        rank1: m.team1SourceRank ?? null,
                        team2: m.groupName2 || null,
                        rank2: m.team2SourceRank ?? null,
                    })
                ),
            };

            setRoundData(mappedRound);
        } catch (error) {
            console.error("Lỗi khi fetch dữ liệu:", error);
        }
    }
    // Handle
    const handleTourRegistrationsReload = () => {
        fetchTourRegistrationsData();
    }
    const handleListParticipantReload = () => {
        getRequestPartner();
        setFocusedRowKey(null)
    }
    // Payment
    const handleOpenPopupConfirmPayment = () => {
        if (listDataConfirmPayment?.length < 1) {
            message.error("Vui lòng chọn ít nhất 1 bản ghi!")
        } else {
            const listDataConfirmPaymentChange = athletePairsWithSTT.filter(item =>
                selectedRowKeyParticipants.some(ap => ap === item.iD)
            );
            setListDataConfirmPayment(listDataConfirmPaymentChange)
            setOpenConfirmPayment(true)
        }

    }

    const handleCancelConfirmPaymentModal = async () => {
        setLoading(true);

        const promises = (listDataConfirmPayment ?? []).map(item => {
            const payload = {
                requestPartnerID: item.iD,
                paymentCompleted: false,
            };
            return axiosInstance.put(`${API_URL}/v1/tournaments/update-request-partner`, payload);

        });

        await Promise.all(promises);
        setLoading(false);

        message.success("Hủy thanh toán thành công!");
        await getRequestPartner();
        await fetchTournamentData();
        setOpenConfirmPayment(false);
        setFocusedRowKey(null)
        setListDataConfirmPayment([])
        rowSelectionParticipant.onChange([], [])
    }

    const handleConfirmPaymentModal = async () => {
        setLoading(true);

        const promises = (listDataConfirmPayment ?? []).map(item => {
            const payload = {
                requestPartnerID: item.iD,
                paymentCompleted: true,
            };
            return axiosInstance.put(`${API_URL}/v1/tournaments/update-request-partner`, payload);

        });

        await Promise.all(promises);
        setLoading(false);

        message.success("Xác nhận thanh toán thành công!");
        await getRequestPartner();
        await fetchTournamentData();
        setOpenConfirmPayment(false);
        setFocusedRowKey(null)
        setListDataConfirmPayment([])
        rowSelectionParticipant.onChange([], [])

    };


    const handlExportExcelParticipant = async () => {
        try {
            const response = await axiosInstance.get(
                `${API_URL}/v1/tournaments/export-excel-participant?tournamentID=${tournamentID}`,
                {
                    responseType: "blob", // quan trọng để nhận file nhị phân
                }
            );

            // Tạo Blob từ dữ liệu response
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            // Lưu file với tên mặc định
            saveAs(blob, "DanhSachCapVDV.xlsx");
        } catch (error) {
            console.error("Export Excel failed:", error);
            alert("Không thể xuất file Excel khi không có dữ liệu!");
        }
    }
    const handleNickNameChange = (value: any) => {
        const selectedAthlete = listUser.find(a => a.userCode === value?.userCode?.toString());
        if (selectedAthlete) {
            formListUser.setFieldsValue({
                id: selectedAthlete.id,
                fullName: selectedAthlete.fullName,
                dateOfBirth: dayjs.utc(selectedAthlete.dateOfBirth),
                gender: selectedAthlete.gender === 1 ? "Nữ" : "Nam",
                point: selectedAthlete.point,
                doublePoint: selectedAthlete.doublePoint,
            });
            setSelectedUser(selectedAthlete.id);
        }
    };
    const handleNickNameParticipant1Change = (value: string) => {
        const selectedAthlete = listTournamentRegistrations.find(a => a.userCode === value);
        setParticipant1(selectedAthlete.requesterId)
        if (selectedAthlete) {
            formListPaticipant1.setFieldsValue({
                id: selectedAthlete.requesterId,
                nickName: selectedAthlete.nickName,
                fullName: selectedAthlete.fullName,
                point: isSingleTournament ? selectedAthlete.point : selectedAthlete.doublePoint,
            });
            updateTotalPoint();
        }
    };
    const handleNickNameParticipant2Change = (value: string) => {
        const selectedAthlete = listTournamentRegistrations.find(a => a.userCode === value);
        setParticipant2(selectedAthlete.requesterId)
        if (selectedAthlete) {
            formListPaticipant2.setFieldsValue({
                id: selectedAthlete.requesterId,
                nickName: selectedAthlete.nickName,
                fullName: selectedAthlete.fullName,
                point: isSingleTournament ? selectedAthlete.point : selectedAthlete.doublePoint,
            });
            updateTotalPoint();
        }
    };
    const updateTotalPoint = () => {
        const point1 = formListPaticipant1.getFieldValue("point") || 0;
        const point2 = formListPaticipant2.getFieldValue("point") || 0;
        formListPaticipant2.setFieldsValue({
            totalPoint: point1 + point2
        });
    };
    const handleMatches1Change = (value: string) => {
        const selectedAthlete = listParticipant.find(a => a.participantNickName === value);

        if (selectedAthlete) {
            formListMatches1.setFieldsValue({
                participantID: selectedAthlete.participantID,
                participant1ID: selectedAthlete.participant1ID,
                participant2ID: selectedAthlete.participant2ID,
                participant1FullName: selectedAthlete.participant1FullName,
                participant2FullName: selectedAthlete.participant2FullName,
                participantNickName: selectedAthlete.participant1NickName + ' - ' + selectedAthlete.participant2NickName,
                participant1Point: selectedAthlete.participant1Point ?? 0,
                participant2Point: selectedAthlete.participant2Point ?? 0
            });
            setMatchInfor1s(selectedAthlete)
        }
    };
    const handleMatches2Change = (value: string) => {
        const selectedAthlete = listParticipant.find(a => a.participantNickName === value);

        if (selectedAthlete) {
            formListMatches2.setFieldsValue({
                participantID: selectedAthlete.participantID,
                participant1ID: selectedAthlete.participant1ID,
                participant2ID: selectedAthlete.participant2ID,
                participant1FullName: selectedAthlete.participant1FullName,
                participant2FullName: selectedAthlete.participant2FullName,
                participantNickName: selectedAthlete.participant1NickName + ' - ' + selectedAthlete.participant2NickName,
                participant1Point: selectedAthlete.participant1Point ?? 0,
                participant2Point: selectedAthlete.participant2Point ?? 0
            });
            setMatchInfor2s(selectedAthlete)
        }
    };
    const handleExit = () => {
        navigate("/tournament");
    };
    const handleOpenMatch = () => {
        navigate(`/tournament/match-management/${tournamentID}`);
    };
    const showModalUser = () => {
        setIsModalUserVisible(true);
        getListUser();
    };

    const handleCancelUser = () => {
        setIsModalUserVisible(false);
    };
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        formListPaticipant1.resetFields();
        formListPaticipant2.resetFields();
    };
    const handleCreateParticipant = async () => {
        try {
            const payload = {
                tournamentID: tournamentID,
                fromProfileID: participant1,
                toProfileID: participant2,
                status: 1,
                isAppCreated: false,
                paymentCompleted: false
            };
            await axiosInstance.post(`${API_URL}/v1/tournaments/create-request-partner-admin`, payload);
            message.success("Tạo cặp ghép đôi thành công!");
            getRequestPartner();
            formListPaticipant1.resetFields();
            formListPaticipant2.resetFields();
            setIsModalVisible(false);
        } catch (error: any) {
            message.error(error?.response?.data.systemMessage);
        }

    };

    // Trận đấu
    const handleOpenMatches = () => {
        setIsModalMatches(true)
        getListParticipant()
    }
    const handleCloseMatches = () => {
        setIsModalMatches(false)
        formListMatches1.resetFields();
    }
    const handleMatchesReload = () => {
        fetchMatches();
    }

    const showCheckDeleteAllMatches = async (handleDeleteAllMatches: () => void) => {
        Modal.confirm({
            title: 'Xác nhận xoá tất cả các trận đấu',
            content: 'Bạn có chắc chắn muốn xoá tất cả các trận đấu trong giải đấu này? Hành động này sẽ không thể hoàn tác.',
            okText: 'Đồng ý',
            width: 500,
            okButtonProps: {
                style: {
                    backgroundColor: "#F48100", borderColor: "#F48100"
                },
            },
            cancelText: 'Hủy bỏ',
            cancelButtonProps: {
                style: {
                    backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100"
                },
            },
            onOk: () => handleDeleteAllMatches(),
        });
    };

    const handleDeleteAllMatches = async () => {
        try {
            await axiosInstance.put(`${API_URL}/v1/matches/delete-all-matches-by-tournament`, { tournamentID: tournamentID });
            message.success("Xóa tất cả các trận đấu thành công!");
            fetchMatches();
        } catch (error: any) {
            message.error(error?.response?.data.systemMessage);
        }
    }

    const handleCreateDataMatches = () => {
        // setIsOpenModelCreateDataMatches(true);
        fetchGroups(); 
        setOpenKnockoutSetupPopup(true);
    }

    const handleCancelModelCreateDataMatches = () => {
        setIsOpenModelCreateDataMatches(false);
        formCreateDataMatches.resetFields();
    }

    const handleConfirmPayment = async (key: any) => {

        const payload = {
            requestPartnerID: key.iD,
            paymentCompleted: true
        };
        await axiosInstance.put(`${API_URL}/v1/tournaments/update-request-partner`, payload);
        message.success("Xác nhận thanh toán thành công!");
        setFocusedRowKey(key.iD);

        await getRequestPartner();
        await fetchTournamentData();
        setTimeout(() => {
            const el = document.querySelector(`[data-row-key="${key.iD}"]`);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 100);
    };

    const handleCancelPayment = async (key: any) => {
        const payload = {
            requestPartnerID: key.iD,
            paymentCompleted: false
        };
        await axiosInstance.put(`${API_URL}/v1/tournaments/update-request-partner`, payload);
        message.success("Huỷ thanh toán thành công!");
        getRequestPartner();
    };

    const handleOpenConfirmUpdatePoint = async () => {
        setOpenConfirmUpdatePoint(true);
    }
    const handleCancelConfirmUpdatePoint = async () => {
        setOpenConfirmUpdatePoint(false);
    }
    const handleConfirmUpdatePoint = async (check: any) => {
        if (check === true) {
            try {
                const payload = {
                    tournamentID: tournamentID,
                }
                await axiosInstance.post(`${API_URL}/v1/tournaments/auto-update-point`, payload);
            } catch (error) {
                console.log(error)
            } finally {
                handleSubmit(3);
                setOpenConfirmUpdatePoint(false);
            }
        } else {
            handleSubmit(3);
            setOpenConfirmUpdatePoint(false);
        }
    }

    // Data-Grid
    const columns: ColumnsType<any> = [

        { title: "STT", dataIndex: "stt", key: "stt", align: 'center', width: 70 },
        { title: "requesterId", dataIndex: "requesterId", key: "requesterId", hidden: true, },
        { title: "Mã người dùng", dataIndex: "userCode", key: "userCode" },
        { title: "NickName", dataIndex: "nickName", key: "nickName" },
        { title: "Họ tên vận động viên", dataIndex: "fullName", key: "fullName" },
        { title: "Ngày sinh", dataIndex: "dateOfBirth", key: "dateOfBirth", render: (text: any) => dayjs(text).format("DD/MM/YYYY"), },
        { title: "Giới tính", dataIndex: "gender", key: "gender", render: (text: any) => (text === 0 ? "Nam" : "Nữ"), },
        { title: "Điểm đơn", dataIndex: "point", key: "point" },
        { title: "Điểm đôi", dataIndex: "doublePoint", key: "doublePoint" },
        {
            title: "Hoạt động",
            key: "actions",
            render: (record: any) => (
                <>
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => deleteTournamentRegistration(record.id)}
                        okText="Có"
                        cancelText="Không"
                    >
                        <Button type="link" icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </>
            ),
        },
    ];

    const athletePairColumns: ColumnsType<any> = useMemo(() => {
        return [
            {
                title: "STT",
                dataIndex: "stt",
                key: "stt",
                align: 'center',
                width: 70,
                render: (_: any, __: any, index: number) => index + 1,
            },
            { title: "Mã người dùng", dataIndex: "fromUserCode", key: "fromUserCode" },
            { title: "NickName", dataIndex: "fromProfileNickName", key: "fromProfileNickName" },
            { title: "VĐV 1", dataIndex: "fromProfileName", key: "fromProfileName" },
            {
                title: "Điểm trình VĐV",
                key: "fromProfilePoint",
                render: (_: any, record: any) => {
                    const point = isSingleTournament ? record.fromProfilePoint : record.fromProfileDoublePoint;
                    return <span style={{ color: "black" }}>{point}</span>;
                },
            },
            { title: "Mã người dùng", dataIndex: "toUserCode", key: "toUserCode" },

            { title: "NickName VĐV", dataIndex: "toProfileNickName", key: "toProfileNickName" },
            { title: "VĐV 2", dataIndex: "toProfileName", key: "toProfileName" },
            {
                title: "Điểm trình VĐV",
                key: "toProfilePoint",
                render: (_: any, record: any) => {
                    const point = isSingleTournament ? record.toProfilePoint : record.toProfileDoublePoint;
                    return <span style={{ color: "black" }}>{point}</span>;
                },
            },
            {
                title: "Điểm tổng",
                key: "totalPoint",
                render: (_: any, record: any) => {
                    const point = isSingleTournament ? record.totalPoint : record.totalDoublePoint;
                    return point;
                },
            },
            {
                title: "Nơi tạo",
                key: "isAppCreated",
                render: (_: any, record: any) => {
                    const isAppCreated = record.isAppCreated === true ? "Tạo bới App" : record.isAppCreated === false ? "Tạo bởi CMS" : "";
                    return isAppCreated;
                },
            },
            // {
            //     title: "Trạng thái ghép đôi",
            //     key: "match",
            //     render: (_: any, record: any) => {
            //         const match = record.status === 0 ? "Chưa ghép đôi" : record.status === 1 ? "Đã ghép đôi" : "";
            //         return match;
            //     },
            // },
            {
                title: "Đã nộp lệ phí",
                key: "paymentCompleted",
                align: 'center',
                render: (_, record) => (
                    <Checkbox checked={record.paymentCompleted} />
                ),
            },
            {
                title: "Hoạt động",
                key: "actions",
                render: (record: any) => (
                    <>
                        <Popconfirm
                            title="Thành viên đã thanh toán?"
                            onConfirm={() => handleConfirmPayment(record)}
                            onCancel={() => handleCancelPayment(record)}
                            okText="Đã thanh toán"
                            cancelText="Huỷ thanh toán"
                        >
                            <Button type="link" icon={<CreditCardOutlined />} danger />
                        </Popconfirm>
                        <Popconfirm
                            title="Bạn có chắc chắn muốn xóa?"
                            onConfirm={() => handleDeleteRequestPartner(record)}
                            okText="Có"
                            cancelText="Không"
                        >
                            <Button type="link" icon={<DeleteOutlined />} danger />
                        </Popconfirm>
                    </>
                ),
            },
        ];
    }, [isSingleTournament]);

    const matchesColumns: ColumnsType<any> = [
        { title: "STT", dataIndex: "stt", key: "stt", align: 'center', width: 70 },
        { title: "matchesID", dataIndex: "matchesID", key: "matchesID", hidden: true, },
        { title: "Cặp vận động viên 1", dataIndex: "participant1_1_1FullName", key: "participant1_1_1FullName", width: 170 },
        { title: "Tổng điểm", dataIndex: "score1", align: 'center', key: "score1" },
        { title: "Cặp vận động viên 2", dataIndex: "participant2_2_2FullName", key: "participant2_2_2FullName", width: 170 },
        { title: "Tổng điểm", dataIndex: "score2", align: 'center', key: "score2" },
        { title: "Vòng đấu", dataIndex: "round", align: 'center', key: "round" },
        { title: "Thứ tự thi đấu", dataIndex: "matchOrder", align: 'center', key: "matchOrder" },
        { title: "Thời gian thi đấu", dataIndex: "startDate", align: 'center', key: "startDate" },
    ];

    const athletePairsWithSTT = athletePairs.map((item, index) => ({
        ...item,
        stt: index + 1,
    }));

    const listtournamentRegistrationsWithSTT = listTournamentRegistrations.map((item, index) => ({
        ...item,
        stt: index + 1,
    }));

    const listMatchesWithSTT = matches.map((item, index) => ({
        ...item,
        stt: index + 1,
    }));
    const listRequestPartnerByAppsWithSTT = listRequestPartnerByApp.map((item, index) => ({
        ...item,
        stt: index + 1,
    }));

    const columnListRequestPartnerByApps: ColumnsType<any> =
        [
            {
                title: "STT",
                dataIndex: "stt",
                key: "stt",
                align: 'center',
                width: 70,
                render: (_: any, __: any, index: number) => index + 1,
            },
            { title: "Mã người dùng", dataIndex: "fromUserCode", key: "fromUserCode" },
            { title: "NickName", dataIndex: "fromProfileNickName", key: "fromProfileNickName" },
            { title: "VĐV 1", dataIndex: "fromProfileName", key: "fromProfileName" },
            {
                title: "Điểm trình VĐV",
                key: "fromProfilePoint",
                render: (_: any, record: any) => {
                    const point = isSingleTournament ? record.fromProfilePoint : record.fromProfileDoublePoint;
                    return <span style={{ color: "black" }}>{point}</span>;
                },
            },
            { title: "Mã người dùng", dataIndex: "toUserCode", key: "toUserCode" },

            { title: "NickName VĐV", dataIndex: "toProfileNickName", key: "toProfileNickName" },
            { title: "VĐV 2", dataIndex: "toProfileName", key: "toProfileName" },
            {
                title: "Điểm trình VĐV",
                key: "toProfilePoint",
                render: (_: any, record: any) => {
                    const point = isSingleTournament ? record.toProfilePoint : record.toProfileDoublePoint;
                    return <span style={{ color: "black" }}>{point}</span>;
                },
            },
            {
                title: "Điểm tổng",
                key: "totalPoint",
                render: (_: any, record: any) => {
                    const point = isSingleTournament ? record.totalPoint : record.totalDoublePoint;
                    return point;
                },
            },
            {
                title: "Trạng thái ghép đôi",
                key: "match",
                render: (_: any, record: any) => {
                    const match = record.status === 0 ? "Chưa ghép đôi" : record.status === 1 ? "Đã ghép đôi" : "";
                    return match;
                },
            },
            {
                title: "Thao tác",
                key: "action",
                render: (_: any, record: any) => (
                    <Space>
                        <Button
                            danger
                            onClick={() => {
                                handleOpenDeleteListRequestPartnerByApp();
                                setSelectedRequestPartnerByApp(record);
                            }}
                        >
                            Xóa
                        </Button>
                    </Space>
                ),
            },
        ];

    const showCloseTournamentConfirm = (status: number, handleSubmit: (status: number) => void) => {
        Modal.confirm({
            title: status === 2 ? 'Xác nhận đóng đăng ký giải đấu' : 'Xác nhận chuyển trạng thái giải đấu',
            content: status === 2 ? 'Bạn có chắc chắn muốn đóng đăng ký giải đấu này? Hành động này sẽ không thể hoàn tác.' : status === 1 ? "Giải đấu sẽ sang giai đoạn đang diễn ra." : "Giải đấu sẽ được mở đăng ký.",
            okText: 'Đồng ý',
            okButtonProps: {
                style: {
                    backgroundColor: "#F48100", borderColor: "#F48100"
                },
            },
            cancelText: 'Hủy bỏ',
            cancelButtonProps: {
                style: {
                    backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100"
                },
            },
            onOk: () => handleSubmit(status),
        });
    };

    // Save
    const handleSubmit = async (status: number) => {
        try {
            const newImagePath = await handleUpload();
            const newQrCodePath = await handleUploadQrCode();
            const values = await form.validateFields();

            setLoading(true);

            const payload = {
                tournamentName: values.tournamentName,
                tournamentScore: values.tournamentScore,
                maximumIndividualScore: values.maximumIndividualScore,
                organize: values.organize,
                organizingTime: values.organizingTime?.format("YYYY-MM-DD"),
                // registerDueDate: values.registerDueDate?.format("YYYY-MM-DD"),
                registerDueDate: values.registerDueDate?.endOf("day").format("YYYY-MM-DDTHH:mm"),
                locationTitle: values.locationTitle,
                locationMap: values.locationMap,
                mapUrl: values.mapUrl,
                paymentInformation: values.paymentInformation,
                qrCode: newQrCodePath,
                registered: values.registered,
                numberUserCompleteFee: values.numberUserCompleteFee,
                sponsor: values.sponsor,
                rule: values.rule,
                isSingleTournament: values.isSingleTournament,
                tournamentImage: newImagePath
            };
            if (tournamentID) {
                if (status !== 0) {
                    const value = { ...payload, status: status, tournamentImage: newImagePath, qrCode: newQrCodePath };
                    await axiosInstance.put(`${API_URL}/v1/tournaments/${tournamentID}`, value);
                } else {
                    await axiosInstance.put(`${API_URL}/v1/tournaments/${tournamentID}`, payload);
                }
                message.success("Giải đấu đã được cập nhật thành công!");
                navigate("/tournament");
            }
            else {
                await axiosInstance.post(`${API_URL}/v1/tournaments`, payload);
                message.success("Giải đấu đã được tạo thành công!");
                navigate("/tournament");
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // Nhận đường dẫn file sau khi upload thành công
    const handleUploadSuccess = (newPath: string) => {
        setImagePath(newPath);
        setHasNewImage(false);
    };

    const handleUploadQrCodeSuccess = (newPath: string) => {
        setQrCode(newPath);
        setHasNewQr(false);
    };

    const handleUpload = async (): Promise<string | null> => {
        if (hasNewImage) {
            return await fileUploadRef.current?.uploadFile() || null;
        }
        return imagePath?.toString() ?? null;
    };
    const handleUploadQrCode = async (): Promise<string | null> => {
        if (hasNewQr) {
            return await qrCodeUploadRef.current?.uploadFile() || null;
        }
        return qrCode?.toString() ?? null;
    };

    const handleSaveMatches = async () => {
        const values = await formListMatches1.validateFields();
        const valueForm = await form.validateFields();
        const startDate = await fromStartDate.validateFields();
        const payload = {
            tournamentID: tournamentID,
            round: values.round ?? 1,
            matchOrder: startDate.matchOrder ?? 1,
            participantID_1: matchInfor1.participantID,
            participantID_2: matchInfor2.participantID ?? null,
            score1: matchInfor1.totalPoint,
            score2: matchInfor2.totalPoint,
            location: valueForm.locationTitle,
            startDate: startDate.startDate ?? dayjs()
        }

        await axiosInstance.post(`${API_URL}/v1/matches/create-matches`, payload);
        message.success("Thêm thành viên tham gia trận đấu thành công!");
        formListMatches1.resetFields();
        formListMatches2.resetFields();
        setIsModalMatches(false);
    };
    const handleCreateTourRegistrations = async () => {
        try {
            const payload = {
                tournamentID: tournamentID,
                requesterId: selectedUser,
            }
            await axiosInstance.post(`${API_URL}/v1/tournaments/register-tournament`, payload);
            message.success("Thêm thành viên tham gia thành công!");
            setLoading(true);
            formListUser.resetFields();
            setIsModalUserVisible(false);
            fetchTourRegistrationsData();
        } catch (error: any) {
            message.error(error?.response?.data?.systemMessage);
        } finally {
            setLoading(false); // khi kết thúc
        }
    };
    const handleSaveCreateDataMatches = async () => {
        try {
            const values = await formCreateDataMatches.validateFields();
            const payload = {
                tournamentID: tournamentID,
                teamCount: Number(values.teamCount),
            };

            await axiosInstance.post(`${API_URL}/v1/matches/create-round`, payload);
            setIsOpenModelCreateDataMatches(false);
            formCreateDataMatches.resetFields();
            fetchMatches();
            message.success("Tạo dữ liệu trận đấu thành công!");
        } catch (error: any) {
            console.log(error?.response?.data.systemMessage);
        }
    }

    // Danh sách VĐV Ghép đôi trên App

    const getRequestPartnerApp = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${API_URL}/v1/tournaments/get-request-partner-app?tournamentID=${tournamentID}`);
            const tournamentResults = response.data;
            const formattedData: RequestPartner[] = tournamentResults.map((item: any) => ({
                key: item.id,
                iD: item.id,
                tournamentID: item.tournamentID,
                fromProfileID: item.fromProfileID,
                fromProfileNickName: item.fromProfileNickName,
                fromUserCode: item.fromUserCode,
                fromProfileName: item.fromProfileName,
                fromProfilePoint: item.fromProfilePoint,
                fromProfileDoublePoint: item.fromProfileDoublePoint,
                toProfileID: item.toProfileID,
                toProfileName: item.toProfileName,
                toProfileNickName: item.toProfileNickName,
                toUserCode: item.toUserCode,
                toProfilePoint: item.toProfilePoint,
                toProfileDoublePoint: item.toProfileDoublePoint,
                paymentCompleted: item.paymentCompleted,
                status: item.status,
                isAppCreated: item.isAppCreated,
                matchTime: item.matchTime,
                totalPoint: ((item.fromProfilePoint ?? 0) + (item.toProfilePoint ?? 0)),
                totalDoublePoint: ((item.fromProfileDoublePoint ?? 0) + (item.toProfileDoublePoint ?? 0)),
            }));

            setListRequestPartnerByApp(formattedData)
            setNumberUserCompleteFee(formattedData.filter(a => a.paymentCompleted === true).length)
        } catch (error) {
            message.error("Không thể tải danh sách lời mời ghép đôi!");
        }
        finally {
            setLoading(false);
        }
    }
    const handleOpenListRequestPartner = () => { setOpenListRequestPartnerByApp(true); getRequestPartnerApp() };

    const handleCloseListRequestPartnerByApp = () => setOpenListRequestPartnerByApp(false);

    const handleOpenDeleteListRequestPartnerByApp = () => { setOpenDeleteRequestPartnerByApp(true); };
    const handleConfirmDeleteListRequestPartnerByApp = async () => {
        try {

            await axiosInstance.put(`/tournaments/delete-request-partner`, { requestPartnerIds: [selectedRequestPartnerByApp.iD] });
            getRequestPartnerApp()
            getRequestPartner();
            message.success("Xoá cặp vận động viên thành công!");
            setOpenDeleteRequestPartnerByApp(false);
        } catch (error) {
            console.error("Lỗi khi xóa cặp vđv", error);
        }
    };
    const handleCloseDeleteListRequestPartnerByApp = () => setOpenDeleteRequestPartnerByApp(false);
    // Bảng thi đấu vòng loại

    const getListParticipantTournamentGroups = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${API_URL}/v1/tournaments/get-list-participant?tournamentID=${tournamentID}`);
            const getListParticipants = response.data;
            const getListParticipant = getListParticipants.map((item: any, index: any) => ({
                ...item,
                stt: index + 1,
            }));
            const formattedData = getListParticipant.map((item: any) => ({
                id: item.participantID,
                name: "(" + item.stt + ') ' + item.participant1NickName + ' - ' + item.participant2NickName
            }));
            setListParticipantTournamentGroups(formattedData)

        } catch (error) {
            console.error("Lỗi khi fetch dữ liệu:", error);
        }
        finally {
            setLoading(false);
        }
    };
    const handleOpenTournamentGroups = () => { getListParticipantTournamentGroups(); setOpenTournamentGroups(true); };
    const handleOpenDeleteTournamentGroups = () => { fetchGroups(); setSelectedGroup(null); setOpenDeleteTournamentGroups(true); };
    const handleCloseDeleteTournamentGroup = () => { setOpenDeleteTournamentGroups(false); }

    const handleCloseTournamentGroup = () => { setOpenTournamentGroups(false); }

    const handleSaveGroups = async (data: GroupStageConfig) => {
        try {
            const now = new Date().toISOString();

            // Chuyển dữ liệu từ FE → model backend
            const payload = {
                tournamentGroups: data.groups.map((g, index) => ({
                    tournamentGroupID: uuidv4(),
                    tournamentID: tournamentID,
                    name: g.name,
                    order: index + 1,
                    createdDate: now,
                    createdBy: "admin",
                    modifiedDate: now,
                    modifiedBy: "admin",

                    // ✅ DANH SÁCH TRẬN
                    tournamentGroupMatches: g.matches.map((m, i) => ({
                        tournamentGroupMatchID: m.id,
                        // tournamentGroupID: "", // Backend có thể tự map
                        matchNumber: i + 1,
                        team1ID: m.team1Id,
                        team2ID: m.team2Id,
                        score1: m.score1 ?? 0,
                        score2: m.score2 ?? 0,
                        winnerID:
                            (m.score1 ?? 0) > (m.score2 ?? 0)
                                ? m.team1Id
                                : (m.score2 ?? 0) > (m.score1 ?? 0)
                                    ? m.team2Id
                                    : null,
                        court: m.court ?? "",
                        matchDate: now,
                        status: true,
                        createdDate: now,
                        updatedDate: now,
                    })),

                    // ✅ DANH SÁCH ĐỘI
                    tournamentGroupTeams: g.teams.map((t) => ({
                        tournamentGroupTeamID: uuidv4(),
                        // tournamentGroupID: "",
                        teamID: t.id,
                        teamName: t.name,
                        wins: 0,
                        losses: 0,
                        draws: 0,
                        points: 0,
                        pointsFor: 0,
                        pointsAgainst: 0,
                        rank: 0,
                        createdDate: now,
                    })),
                })),
            };

            console.log("📦 Dữ liệu gửi API:", payload);

            // Gọi API lưu
            await axiosInstance.post(`${API_URL}/v1/tournament-group`, payload);
            handleCloseTournamentGroup();
            matchEditorRef.current?.reload();

            // message.success("Đã lưu cấu hình vòng bảng thành công!");
        } catch (err) {
            console.error(err);
            // message.error("Lỗi khi lưu cấu hình vòng bảng!");
        }
    };

    const handleConfirmDeleteTournamentGroup = async () => {
        try {
            await axiosInstance.put(`${API_URL}/v1/tournament-group/delete-tournament-group`, { tournamentGroupIDs: [selectedGroup] });
            handleCloseDeleteTournamentGroup();
            matchEditorRef.current?.reload();

            message.success("Xoá vòng bảng thành công!");
        }
        catch (err) {
            console.error(err);
        }
    }
    // Tạo dữ liệu trận đấu
    const handleSaveKnockoutSetupPopup = async (data: RoundConfig) => {
        const now = new Date().toISOString();

        const payload = {
            tournamentID: tournamentID,
            totalTeams: data.totalTeams,
            createdDate: now,
            tournamentMatchConfigs: data.matches.map((m) => ({
                matchNumber: m.matchesCode,
                team1SourceGroup: m.team1,
                team1SourceRank: m.rank1 ?? 0,
                team2SourceGroup: m.team2,
                team2SourceRank: m.rank2 ?? 0,
                createdDate: now,
            })),
        };
        try {

            await axiosInstance.post(`${API_URL}/v1/tournament-round`, payload);
        } catch (error) {
            console.error("💥 Lỗi khi gửi API:", error);
            message.error("Gửi API thất bại!");
        }

        fetchTournamentMatchConfig();
    }

    const handleOpenConfirmCreateDataMatches = () => {
        setOpenConfirmCreateDataMatches(true);
    }

    const handleConfirmCreateDataMatches = async () => {
        try {
            await axiosInstance.post(`${API_URL}/v1/tournament-round/create-auto-tournament-round`, { tournamentID });
            fetchMatches();
            setOpenConfirmCreateDataMatches(false);
            message.success("Tạo dữ liệu trận đấu thành công!");
        } catch (error: any) {
            const msg = error.response?.data?.systemMessage || "Có lỗi xảy ra, vui lòng thử lại!";
            const lowerMsg = msg.toLowerCase();

            if (lowerMsg.includes("chưa có điểm") || lowerMsg.includes("không thể tạo vòng mới")) {
                Modal.error({
                    title: "Không thể tạo vòng đấu mới",
                    content: <div style={{ whiteSpace: "pre-line" }}>{msg}</div>,
                    width: 700,
                });
            } else {
                message.error(msg);
            }
        }
    }
    const handleCancelCreateDataMatches = () => {
        setOpenConfirmCreateDataMatches(false);
    }

    return (
        <div style={{ padding: "20px" }}>
            <Form layout="vertical" form={form}>
                {/* Thông tin chung giải đấu */}
                <Card title="Thông tin chung giải đấu" style={{ marginBottom: 20 }}>
                    <Row>
                        <Col span={6}>
                            <div style={{ marginBottom: 20, height: 240 }}>
                                <FileUpload
                                    expectedWidth={710}
                                    expectedHeight={400}
                                    width={376}
                                    height={220}
                                    ref={fileUploadRef}
                                    unit="tournament"
                                    type="avatar"
                                    initialFilePath={imagePath}
                                    onUploadSuccess={handleUploadSuccess}
                                    onFileSelected={() => setHasNewImage(true)} />
                            </div>
                            <p className="text-gray-500 text-sm" >Tải lên hình ảnh với kích thước 710*400</p>
                        </Col>
                        <Col span={18}>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item label="Tên giải đấu" name="tournamentName">
                                        <Input placeholder="Nhập tên giải đấu" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Điểm trình giải đấu"
                                        name="tournamentScore"
                                        rules={[
                                            { required: true, message: "Vui lòng nhập điểm trình giải đấu!" },
                                        ]}
                                    >
                                        <InputNumber
                                            min={100}
                                            max={999}
                                            step={10}
                                            style={{ width: "100%" }}
                                            placeholder="Nhập điểm trình giải đấu"
                                        />
                                    </Form.Item>

                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Điểm cá nhân tối đa" name="maximumIndividualScore" rules={[
                                        { required: true, message: "Vui lòng nhập điểm cá nhân tối đa!" },
                                    ]}>
                                        <InputNumber
                                            min={100}
                                            max={999}
                                            step={10}
                                            style={{ width: "100%" }} placeholder="Nhập điểm cá nhân tối đa" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item label="Đơn vị tổ chức" name="organize">
                                        <Input placeholder="Nhập đơn vị tổ chức" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Thời gian tổ chức" name="organizingTime" rules={[
                                        { required: true, message: "Vui lòng chọn thời gian tổ chức!" }
                                    ]}>
                                        <DatePicker placeholder="Chọn ngày" style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Hạn cuối đăng ký" name="registerDueDate">
                                        <DatePicker placeholder="Chọn ngày" style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item label="Địa chỉ tổ chức" name="locationTitle">
                                        <Input placeholder="Nhập địa chỉ tổ chức" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Số đội dự kiến" name="registered">
                                        <Input placeholder="Nhập số đội dự kiến" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Số VĐV hoàn thành lệ phí">
                                        <Input placeholder="Nhập số VĐV hoàn thành lệ phí" disabled value={numberUserCompleteFee} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item name="isSingleTournament" valuePropName="checked">
                                        <Checkbox>Giải đấu đơn</Checkbox>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>

                {/* Thông tin vinh danh nhà tài trợ */}
                <Card title="Thông tin vinh danh nhà tài trợ" style={{ marginBottom: 16 }}>
                    {/* <Form.Item name="sponsor">
                        <TextArea placeholder="Nhập tên tài trợ vinh danh" />
                    </Form.Item> */}
                    <Form.Item name="sponsor">
                        <CKEditor
                            editor={ClassicEditor}
                            data={form.getFieldValue('sponsor')}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                form.setFieldsValue({ sponsor: data });
                            }}
                            config={{
                                placeholder: "Nhập nội dung tại đây..."
                            }}
                        />
                    </Form.Item>
                </Card>

                {/* Thông tin điều lệ */}
                <Card title="Thông tin điều lệ" style={{ marginBottom: 16 }}>
                    {/* <Form.Item name="rule" >
                        <TextArea placeholder="Nhập điều lệ giải đấu" />
                    </Form.Item> */}
                    <Form.Item name="rule">
                        <CKEditor
                            editor={ClassicEditor}
                            data={form.getFieldValue('rule')}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                form.setFieldsValue({ rule: data });
                            }}
                            config={{
                                placeholder: "Nhập nội dung tại đây..."
                            }}
                        />
                    </Form.Item>
                </Card>
                <Card title="Thông tin thanh toán" style={{ marginBottom: 16 }}>
                    {/* <Form.Item name="rule" >
                        <TextArea placeholder="Nhập điều lệ giải đấu" />
                    </Form.Item> */}
                    <Form.Item name="paymentInformation">
                        <CKEditor
                            editor={ClassicEditor}
                            data={form.getFieldValue('paymentInformation')}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                form.setFieldsValue({ paymentInformation: data });
                            }}
                            config={{
                                placeholder: "Nhập nội dung tại đây..."
                            }}
                        />
                    </Form.Item>
                    <Col span={6}>
                        <div style={{ marginBottom: 20, height: 240 }}>
                            <FileUpload
                                expectedWidth={600}
                                expectedHeight={600}
                                width={240}
                                height={240}
                                ref={qrCodeUploadRef}
                                unit="tournament"
                                type="QRCode"
                                initialFilePath={qrCode}
                                onUploadSuccess={handleUploadQrCodeSuccess}
                                onFileSelected={() => setHasNewQr(true)} />
                        </div>
                        <p className="text-gray-500 text-sm" >Tải lên hình ảnh với kích thước 600*600</p>
                    </Col>
                </Card>
                {/* Thông tin sơ đồ & địa điểm thi đấu */}
                <Card title="Thông tin sơ đồ & địa điểm thi đấu" style={{ marginBottom: 16 }}>
                    <Form.Item name="locationMap" label={<strong>Địa điểm thi đấu</strong>}>
                        <CKEditor
                            editor={ClassicEditor}
                            data={form.getFieldValue('locationMap')}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                form.setFieldsValue({ locationMap: data });
                            }}
                            config={{
                                placeholder: "Nhập nội dung tại đây..."
                            }}
                        />
                    </Form.Item>
                    <Form.Item name="mapUrl" label={<strong>Link google map</strong>}>
                        <TextArea placeholder="Nhập link google map" />
                    </Form.Item>
                </Card>

                {/* Danh sách vận động viên tham gia */}
                <Card title="Danh sách vận động viên tham gia" style={{ marginBottom: 16 }}>
                    <Button disabled={isEditing} type="primary" icon={<PlusOutlined />} style={{ marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={showModalUser}>
                        Thêm mới
                    </Button>
                    <Button icon={<ReloadOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={handleTourRegistrationsReload}>
                        Làm mới
                    </Button>
                    {loading ? (
                        <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                    ) : (
                        <Table rowKey={record => record.id} rowSelection={rowSelection} dataSource={listtournamentRegistrationsWithSTT} columns={columns} pagination={false} scroll={{ y: 600 }} />)}
                </Card>
                <Modal
                    title=
                    "Thêm mới vận động viên"
                    visible={isModalUserVisible}
                    onCancel={handleCancelUser}
                    footer={[
                        <Button key="cancel" onClick={handleCancelUser} style={{ backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }}>
                            Thoát
                        </Button>,
                        <Button key="submit" type="primary" style={{ backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={handleCreateTourRegistrations}>
                            Lưu
                        </Button>,
                    ]}
                >
                    <Form form={formListUser} layout="vertical">
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="NickName"
                                    name="nickName"
                                    rules={[{ required: true, message: "Vui lòng chọn NickName VĐV!" }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Chọn NickName VĐV"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => {
                                            const children = option?.children ?? '';
                                            const text =
                                                typeof children === 'string'
                                                    ? children
                                                    : Array.isArray(children)
                                                        ? children.join('')
                                                        : String(children);
                                            return text.toLowerCase().includes(input.toLowerCase());
                                        }}
                                        onChange={(value, option) => {
                                            if (option && !Array.isArray(option)) {
                                                handleNickNameChange(option.item);
                                            }
                                        }}
                                    >
                                        {listUser.map((athlete) => (
                                            <Select.Option
                                                key={athlete.userCode}
                                                value={athlete.userCode}
                                                item={athlete} // gắn object gốc để lấy lại khi onChange
                                            >
                                                {athlete.userCode} - {athlete.nickName}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="Họ tên vận động viên" name="fullName">
                                    <Input placeholder="Nhập họ tên VĐV" disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Ngày sinh" name="dateOfBirth">
                                    <DatePicker style={{ width: "100%" }} disabled />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Giới tính" name="gender">
                                    <Input placeholder="Nhập giới tính" disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Điểm đơn" name="point">
                                    <Input placeholder="Nhập điểm đơn" disabled />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Điểm đôi" name="doublePoint">
                                    <Input placeholder="Nhập điểm đôi" disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>

                <Card title="Danh sách vận động viên đã ghép cặp" style={{ marginBottom: 16 }}>

                    <Button type="primary" disabled={isEditing} icon={<PlusOutlined />} style={{ marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={showModal}>Thêm mới</Button>
                    <Button icon={<ReloadOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={handleListParticipantReload}>Làm mới</Button>
                    <Button icon={<AppstoreOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={handleOpenListRequestPartner}>Ghép đôi trên App</Button>
                    <Button icon={<CreditCardOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={handleOpenPopupConfirmPayment}>Thanh toán</Button>
                    <Button type="primary" icon={<FileExcelOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={handlExportExcelParticipant}>Xuất Excel</Button>
                    {loading ? (
                        <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                    ) : (<Table rowSelection={rowSelectionParticipant}
                        dataSource={athletePairsWithSTT}
                        columns={athletePairColumns}
                        pagination={false}
                        scroll={{ y: 600 }}
                        rowClassName={(record) =>
                            record.iD === focusedRowKey ? "focused-row" : ""
                        }
                    />)}
                </Card>
                <Modal
                    title="Thêm mới cặp vận động viên"
                    open={isModalVisible}
                    onCancel={handleCancel}
                    width={700}
                    footer={[
                        <Button key="cancel" onClick={handleCancel} style={{ backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }}>
                            Thoát
                        </Button>,
                        <Button key="submit" onClick={handleCreateParticipant} type="primary" style={{ backgroundColor: "#F48100", borderColor: "#F48100" }}>
                            Lưu
                        </Button>,
                    ]}
                >
                    <Form form={formListPaticipant1} layout="vertical">
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item label="ID vận động viên 1" name="nickName" style={{ width: "100%" }}>
                                    <Select showSearch placeholder="Nhập ID VĐV 1" filterOption={(input, option) => {
                                        const children = option?.children ?? '';
                                        const text =
                                            typeof children === 'string'
                                                ? children
                                                : Array.isArray(children)
                                                    ? children.join('')
                                                    : String(children);
                                        return text.toLowerCase().includes(input.toLowerCase());
                                    }} onChange={handleNickNameParticipant1Change}>
                                        {listTournamentRegistrations.map(athlete => (
                                            <Option key={athlete.userCode} value={athlete.userCode}>
                                                {athlete.userCode} - {athlete.nickName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Họ tên vận động viên 1" name="fullName">
                                    <Input placeholder="Nhập họ tên VĐV 1" disabled />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Điểm của vận động viên" name="point">
                                    <Input placeholder="Nhập điểm của vận động viên" disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>

                    <Form form={formListPaticipant2} layout="vertical">
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item label="ID vận động viên 2" name="nickName">
                                    <Select showSearch placeholder="Nhập ID VĐV 2" filterOption={(input, option) => {
                                        const children = option?.children ?? '';
                                        const text =
                                            typeof children === 'string'
                                                ? children
                                                : Array.isArray(children)
                                                    ? children.join('')
                                                    : String(children);
                                        return text.toLowerCase().includes(input.toLowerCase());
                                    }} onChange={handleNickNameParticipant2Change}>
                                        {listTournamentRegistrations.map(athlete => (
                                            <Option key={athlete.userCode} value={athlete.userCode}>
                                                {athlete.userCode} - {athlete.nickName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Họ tên vận động viên 2" name="fullName">
                                    <Input placeholder="Nhập họ tên VĐV 2" disabled />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Điểm của vận động viên" name="point" >
                                    <Input placeholder="Nhập điểm của vận động viên" disabled />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item label="Điểm tổng" name="totalPoint">
                                    <InputNumber placeholder="Nhập tổng điểm" min={0} style={{ width: 210 }} disabled
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <Modal
                    title="Xác nhận thanh toán cho vận động viên"
                    open={isOpenConfirmPayment}
                    onOk={handleConfirmPaymentModal}
                    onCancel={() => setOpenConfirmPayment(false)}
                    okText="Thanh toán"
                    cancelText="Huỷ thanh toán"
                    width={600}
                    okButtonProps={{ danger: false }}
                    footer={[
                        <Button key="back" onClick={handleCancelConfirmPaymentModal}>
                            Huỷ thanh toán
                        </Button>,
                        <Button key="submit" type="primary" onClick={handleConfirmPaymentModal}>
                            Thanh toán
                        </Button>,
                    ]}
                >
                    <p>Bạn có chắc muốn thực hiện thanh toán cho các cặp vận động viên này?</p>
                    <div style={{ maxHeight: 300, overflowY: "auto" }}>
                        {listDataConfirmPayment?.map((athletePair, index) => (
                            <p key={athletePair.stt}>
                                {"("}{athletePair.stt}{")"} {athletePair.fromProfileNickName}-{athletePair.fromUserCode} {" và "} {athletePair.toProfileNickName}-{athletePair.toUserCode}
                            </p>
                        ))}
                    </div>
                </Modal>
                {/* Popup cặp vđv gửi lời mời trên app */}
                <Modal
                    open={isOpenListRequestPartnerByApp}
                    title="Danh sách các cặp vận động viên"
                    width={1400}
                    onCancel={handleCloseListRequestPartnerByApp}
                    footer={null}
                >
                    <Table
                        dataSource={listRequestPartnerByAppsWithSTT}
                        columns={columnListRequestPartnerByApps}
                        pagination={false}
                        rowKey="key"
                        scroll={{ y: 600 }}
                    />
                </Modal>
                <Modal
                    open={isOpenDeleteRequestPartnerByApp}
                    title="Xác nhận xóa"
                    onCancel={() => handleCloseDeleteListRequestPartnerByApp()}
                    onOk={handleConfirmDeleteListRequestPartnerByApp}
                    okText="Xóa"
                    okButtonProps={{ danger: true }}
                    cancelText="Hủy"
                >
                    <p>
                        Bạn có chắc muốn xóa cặp{" "}
                        <strong>
                            {selectedRequestPartnerByApp?.fromUserCode}_{selectedRequestPartnerByApp?.fromProfileNickName} & {selectedRequestPartnerByApp?.toUserCode}_{selectedRequestPartnerByApp?.toProfileNickName}
                        </strong>{" "}
                        không?
                    </p>
                </Modal>
                {/* End  */}
                <Modal
                    title="Thêm mới thành viên cho trận đấu"
                    open={isModalMatches}
                    onCancel={handleCloseMatches}
                    width={700}
                    footer={[
                        <Button key="cancel" onClick={handleCloseMatches} style={{ backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }}>
                            Thoát
                        </Button>,
                        <Button key="submit" onClick={handleSaveMatches} type="primary" style={{ backgroundColor: "#F48100", borderColor: "#F48100" }}>
                            Lưu
                        </Button>,
                    ]}
                >
                    <Form form={formListMatches1} layout="vertical">
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item label="Chọn cặp vận động viên 1" style={{ width: "100%" }} rules={[{ required: true, message: "Vui lòng chọn cặp vận động viên!" }]}>
                                    <Select showSearch placeholder="Chọn cặp vận động viên" onChange={handleMatches1Change}>
                                        {listParticipant.map(athlete => (
                                            <Option key={athlete.participantNickName} value={athlete.participantNickName}>
                                                {athlete.participantNickName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Họ tên vận động viên 1" name="participant1FullName">
                                    <Input placeholder="Nhập họ tên VĐV 1" disabled />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Họ tên vận động viên 2" name="participant2FullName">
                                    <Input placeholder="Nhập họ tên VĐV 2" disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <Form form={formListMatches2} layout="vertical">
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item label="Chọn cặp vận động viên 2" style={{ width: "100%" }} rules={[{ required: true, message: "Vui lòng chọn cặp vận động viên!" }]}>
                                    <Select showSearch placeholder="Chọn cặp vận động viên" onChange={handleMatches2Change}>
                                        {listParticipant.map(athlete => (
                                            <Option key={athlete.participantNickName} value={athlete.participantNickName}>
                                                {athlete.participantNickName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Họ tên vận động viên 1" name="participant1FullName">
                                    <Input placeholder="Nhập họ tên VĐV 1" disabled />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Họ tên vận động viên 2" name="participant2FullName">
                                    <Input placeholder="Nhập họ tên VĐV 2" disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>

                    <Form form={fromStartDate}>
                        <Row gutter={16}>

                            <Col span={12}>

                                <Form.Item label="Thời gian thi đấu" name="startDate">
                                    <DatePicker defaultValue={dayjs()} placeholder="Chọn ngày" style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Thứ tự thi đấu" name="matchOrder">
                                    <Input placeholder="Nhập thứ tự thi đấu" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>

                <Card title="Bảng đấu" style={{ marginBottom: 16 }}>
                    <Button icon={<PlusOutlined />} type="primary" style={{ marginLeft: 10, marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={handleOpenTournamentGroups}>
                        Bảng thi đấu vòng loại
                    </Button>
                    <GroupStageManagerPopup
                        open={isOpenTournamentGroup}
                        onClose={handleCloseTournamentGroup}
                        teams={listParticipantTournamentGroup}
                        onSave={handleSaveGroups}
                    />
                    <GroupStageMatchEditor ref={matchEditorRef}
                        tournamentId={tournamentID ?? ''} />


                    <Modal
                        open={isOpenDeleteTournamentGroup}
                        title="Xóa thông tin bảng đấu"
                        onCancel={() => handleCloseDeleteTournamentGroup()}
                        onOk={handleConfirmDeleteTournamentGroup}
                        okText="Đồng ý"
                        okButtonProps={{ danger: true }}
                        cancelText="Hủy"
                    >
                        <Select
                            style={{ width: "100%" }}
                            placeholder="Chọn bảng đấu cần xóa"
                            value={selectedGroup ?? undefined}
                            onChange={(value) => setSelectedGroup(value)}
                            options={groups
                                .map((g) => ({
                                    label: g.group, // ✅ hiển thị “Bảng A”
                                    value: g.id, // ID bảng đấu
                                }))
                                .sort((a, b) => a.label.localeCompare(b.label, "vi", { numeric: true }))} // sắp theo thứ tự A, B, C
                        />
                    </Modal>
                </Card>

                {/* Danh sách vận động viên tham gia */}
                <Card title="Cấu hình trận" style={{ marginBottom: 16 }}>
                    <Button icon={<PlusOutlined />} disabled={isCreateDataMatches} type="primary" style={{ marginLeft: 10, marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={handleCreateDataMatches}>
                        Cấu hình trận
                    </Button>
                    <Button icon={<SaveOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={handleOpenConfirmCreateDataMatches}>
                        Tạo dữ liệu trận
                    </Button>
                    {loading ? (
                        <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                    ) : (
                        <div style={{ marginTop: 24 }}>
                            <KnockoutMatchTable data={roundData} />
                        </div>)}
                </Card>
                <Card title="Danh sách các trận đấu" style={{ marginBottom: 16 }}>

                    <Button icon={<ReloadOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={handleMatchesReload}>
                        Làm mới
                    </Button>
                    <Button icon={<DeleteOutlined />} danger style={{ marginLeft: 10, marginBottom: 10 }} onClick={async (event: any) => { showCheckDeleteAllMatches(handleDeleteAllMatches) }}>
                        Xoá các trận đấu
                    </Button>
                    {loading ? (
                        <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                    ) : (
                        <Table dataSource={listMatchesWithSTT} columns={matchesColumns} pagination={false} scroll={{ y: 600 }} />)}
                </Card>
                <Modal
                    title="Cập nhật dữ liệu trận đấu"
                    open={isOpenModelCreateDataMatches}
                    onCancel={handleCancelModelCreateDataMatches}
                    width={300}
                    footer={[
                        <Button key="cancel" style={{ backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={handleCancelModelCreateDataMatches}>
                            Thoát
                        </Button>,
                        <Button key="submit" type="primary" style={{ backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={handleSaveCreateDataMatches}>
                            Tạo dữ liệu
                        </Button>,
                    ]}
                >
                    <Form layout="vertical" form={formCreateDataMatches}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    label="Chọn số đội tham gia"
                                    name="teamCount"
                                    rules={[{ required: true, message: "Vui lòng chọn số đội tham gia" }]}
                                >
                                    <Select placeholder="Chọn số đội tham gia" allowClear style={{ width: "100%" }}>
                                        {[2, 4, 8, 16, 32, 64, 128].map((teamCount) => (
                                            <Select.Option key={teamCount} value={teamCount}>
                                                {teamCount} đội
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <Modal
                    title="Xác nhận cập nhật điểm tự động"
                    open={isOpenConfirmUpdatePoint}
                    onCancel={handleCancelConfirmUpdatePoint}
                    width={500}
                    footer={[
                        <Button key="cancel" style={{ backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={async (event: any) => handleConfirmUpdatePoint(false)}>
                            Không tự động
                        </Button>,
                        <Button key="submit" type="primary" style={{ backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={async (event: any) => handleConfirmUpdatePoint(true)}>
                            Tự động
                        </Button>
                    ]}
                >
                    <p>-  Đôi vận động viên vô địch , mỗi người + 0.15 điểm</p>
                    <p>-  Đôi vận động viên nhì , mỗi người + 0.10 điểm</p>
                    <p>-  Đôi vận động viên ba , mỗi người + 0.05 điểm</p>
                </Modal>
                <Modal
                    open={isOpenConfirmCreateDataMatches}
                    title="Xác nhận tạo dữ liệu trận đấu"
                    onOk={handleConfirmCreateDataMatches}
                    onCancel={handleCancelCreateDataMatches}
                    okText="Đồng ý"
                    cancelText="Hủy"
                    okButtonProps={{ type: "primary" }}
                >
                    <p>
                        Bạn sẽ tạo dữ liệu trận đấu theo cấu hình đã cài đặt.
                        <br />
                        Hệ thống sẽ sinh ra danh sách trận đấu dựa trên các bảng và đội hiện có.
                    </p>
                </Modal>
                <KnockoutSetupPopup
                    open={isOpenKnockoutSetupPopup}
                    onClose={() => setOpenKnockoutSetupPopup(false)}
                    groups={groups}
                    onSave={handleSaveKnockoutSetupPopup}
                    tournamentID={tournamentID ? tournamentID : ""}
                />

            </Form>
            <div style={{ display: "flex", justifyContent: "end", marginTop: 16, marginRight: 20 }}>
                <Button style={{ marginRight: 10, backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={handleExit}>Thoát</Button>
                <Button style={{ marginRight: 10, backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={handleOpenMatch}>Sơ đồ trận đấu</Button>
                <Button style={{ marginRight: 10, backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} type="primary" hidden={!isEditing} onClick={async (event: any) => showCloseTournamentConfirm(2, handleSubmit)}>Đóng đăng ký giải</Button>
                <Button style={{ marginRight: 10, backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} type="primary" hidden={!isEditing} onClick={async (event: any) => showCloseTournamentConfirm(1, handleSubmit)}>Đang diễn ra</Button>
                <Button style={{ marginRight: 10, backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} type="primary" hidden={!isEditing} onClick={handleOpenConfirmUpdatePoint}>Kết thúc giải</Button>
                <Button style={{ marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} type="primary" onClick={async (event: any) => showCloseTournamentConfirm(0, handleSubmit)}>Tiếp tục</Button>
            </div>
        </div>

    );
};

export default TournamentDetail;